import {PHASES} from "../../../constants/phases";
import {FLAG_PREFIX} from "../../../constants/tokens";
import {
  selectHexes,
  selectPhase,
  selectSpecialBuildings,
  selectStartingQuarters,
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {getActingPlayerFromState} from "../../players/getActingPlayer";
import {calculateCitiesCache} from "../calculateCitiesCache";

/**
 * Свой стартовый квартал в фазе расстановки: игрок видит свой выбор сразу, а чужой
 * (и выбор бота) скрыт до конца расстановки — как чужие размещения в начале игры. В
 * hexes такого квартала нет: там до конца расстановки стоит флаг, а выбор лежит в
 * startingQuarters.
 *
 * @param {Object} state
 * @returns {{hexKey: string, tokenType: string}|null}
 */
export const resolveOwnStartingQuarter = (state) => {
  if (selectPhase(state) !== PHASES.SETUP) {
    return null;
  }

  const actingPlayer = getActingPlayerFromState(state);
  const startingQuarters = selectStartingQuarters(state);
  if (!actingPlayer || actingPlayer.isBot || !startingQuarters) {
    return null;
  }

  const hexKey = startingQuarters[actingPlayer.id];
  return hexKey ? {hexKey, tokenType: `central_quarter_${actingPlayer.color}`} : null;
};

/**
 * Поле таким, каким его видит игрок: свой стартовый квартал уже стоит на своей ячейке.
 * По нему считается зона кварталов в фазе расстановки. Кэш городов считается вместе с
 * ячейками: по нему первый раунд ищет, где строить, и без своего города соседние ячейки
 * показывались бы закрытыми для базового квартала. Флаги в кэш не идут, как и у
 * редьюсера в конце расстановки
 *
 * @param {Object} state
 * @returns {Object} то же состояние, если своего квартала нет
 */
export const withOwnStartingQuarter = (state) => {
  const startingQuarter = resolveOwnStartingQuarter(state);
  if (!startingQuarter) {
    return state;
  }
  const hexes = {...selectHexes(state), [startingQuarter.hexKey]: startingQuarter.tokenType};
  const hexesWithoutFlags = Object.fromEntries(
    Object.entries(hexes).filter(([, token]) => !String(token).startsWith(FLAG_PREFIX))
  );
  return {
    ...state,
    shared: {
      ...state.shared,
      hexes,
      gameState: {
        ...state.shared.gameState,
        citiesCache: calculateCitiesCache(hexesWithoutFlags, selectSpecialBuildings(state)),
      },
    },
  };
};
